import { IBaseModel } from '../../shared/interfaces/IBaseModel';
import { IPagination } from '../../shared/interfaces/IPagination';
import { ITruck } from '../../shared/interfaces/ITruck';
import { requests } from '../../utils/api/api.service';
import { TRUCK_URL } from '../../utils/api/endpoints';

export const AdminTruckService = {
  getAll: (data: IPagination): Promise<IBaseModel<ITruck[]>> =>
    requests.get(TRUCK_URL, data),
  getSingle: (id: number): Promise<ITruck> =>
    requests.get(`${TRUCK_URL}/${id}`),
  create: (data: ITruck): Promise<ITruck> => requests.post(TRUCK_URL, data),
  update: (data: ITruck): Promise<ITruck> =>
    requests.put(`${TRUCK_URL}/${data?.id}`, data),
  delete: (id: number) => requests.delete(`${TRUCK_URL}/${id}`),
};
